import React from 'react';
import PropTypes from 'prop-types';

import CardGrid from './CardGrid';

import TagsFilter from 'components/TagsFilter';

import Description from 'ui/text/Description';
import Subtitle from 'ui/text/Subtitle';

const ptProducts = [24, 480, 481];

const asaFilter = (product) => {
  if (navigator.language.includes('pt')) {
    return ptProducts.includes(product.id);
  } else {
    return !ptProducts.includes(product.id);
  }
};

const ProductsList = ({products, onAction, organizationSlug, organizationTags, activeTag}) => {

  const showTags = organizationTags && organizationTags.length > 0;

  const isAsaPerafita = organizationSlug == 'asa-perafita';

  const filteredProducts =  isAsaPerafita
                              ? products.filter(asaFilter)
                              : products;

  if (isAsaPerafita && !filteredProducts.length) {
    return (
      <div className='stores-content'>
        <Subtitle>
          Esgotado
        </Subtitle>
        <Description>
          Parque completamente reservado. 
          Por favor, verifique a disponibilidade mais tarde.
        </Description>
        <Subtitle>
          Sold Out
        </Subtitle>
        <Description>
          Our park is currently fully booked. 
          Please check back later for availability.
        </Description>
      </div>
    );
  }

  return (
    <div className='stores-content'>
      {showTags &&
        <TagsFilter
          organizationSlug={organizationSlug}
          organizationTags={organizationTags}
          activeTag={activeTag} />}

      <CardGrid 
        products={filteredProducts}
        organizationTags={organizationTags}
        onAction ={onAction} />
    </div>
  );
};

ProductsList.propTypes = {
  products: PropTypes.array,
  onAction: PropTypes.func,
  organizationSlug: PropTypes.string,
  organizationTags: PropTypes.array,
  activeTag: PropTypes.string,
};

export default ProductsList;
